import { MoodEnum } from 'app/utils/enums/timesheet.enum';

export interface Mood {
  value: MoodEnum;
  name: string;
  icon: string;
}

export const MOOD_INFO: Record<MoodEnum, Mood> = {
  [MoodEnum.HAPPY]: {
    value: MoodEnum.HAPPY,
    name: 'Happy',
    icon: 'assets/images/happy-active.png',
  },
  [MoodEnum.NOT_SURE]: {
    value: MoodEnum.NOT_SURE,
    name: 'Average',
    icon: 'assets/images/average-active.png',
  },
  [MoodEnum.SAD]: {
    value: MoodEnum.SAD,
    name: 'Unhappy',
    icon: 'assets/images/unhappy-active.png',
  },
};

export const MOODS: Mood[] = Object.values(MOOD_INFO);
